// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-main[data-v-6b3b2fec]{height:calc(100vh - 60px);width:100%;position:relative;overflow:hidden}.fixed-header+.app-main[data-v-6b3b2fec]{padding-top:50px}", ""]);
// Exports
module.exports = exports;
